export default __webpack_public_path__ + "static/media/blue.1adfe283.jpg";